import LogRocket from 'logrocket';
import { isObject as _isObject, isString as _isString } from 'lodash';
import setupLogRocketReact from 'logrocket-react';
import { parse } from 'query-string';
import { getUserDetails, getWavetrakIdentity } from '@surfline/web-common';

import config from '../config';

/**
 * @param {ReturnType<import('../stores/index').default>} store
 */
export const setupLogRocket = (store) => {
  const queryString = window.location?.search;

  if (queryString) {
    const query = parse(queryString);
    const { anonymousId } = getWavetrakIdentity() || {};

    const logRocketEnabled = query?.logrocket === 'on';
    const shouldEnableForAnonymousId = [
      'undefined',
      'Undefined',
      'null',
      '903d9f60-4b95-11eb-b3f1-eff3812e484b',
    ].includes(anonymousId);

    if (logRocketEnabled || shouldEnableForAnonymousId) {
      LogRocket.init(config.appKeys.logrocket, {
        network: {
          requestSanitizer:
            /** @param {Request} req */
            (req) => {
              req.headers['X-Auth-AccessToken'] = 'redacted';
              req.url = req.url.replace(/access(_)?token=([^&]*)/, 'accesstoken=**redacted**');

              if (_isObject(req.body)) {
                delete req.password; // Remove password so that we don't log in LogRocket
                delete req.access_token;
                delete req.accesstoken;
              }

              if (_isString(req.body)) {
                req.body = req.body.replace(/password=([^&]*)/, 'password=**redacted**');
                req.body = req.body.replace(/access(_)?token=([^&]*)/, 'accesstoken=**redacted**');
              }

              return req;
            },
        },
      });

      setupLogRocketReact(LogRocket);

      const storeState = store.getState();
      const userData = getUserDetails(storeState);

      if (userData) {
        LogRocket.identify(userData?._id || anonymousId, {
          name: `${userData.firstName} ${userData.lastName}`,
          email: userData.email,
        });
      }
    }
  }
};
